import LineHeight15 from '@assets/icons/line-height-15.svg'
import { Icon } from './Icon'

export const LineHeight15Icon = Icon(LineHeight15)
